import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeotabEulaService {
  private _isEULAAccepted: boolean | null = null;
  public credentials: any;

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private accessService: AccessService,
    private dataService: DataService
  ) {
    this.credentials = JSON.parse(sessionStorage.getItem('rideview:credentials'));
    this.accessService.currentFleet = this.credentials.database;
    this.dataService.currentFleet = this.credentials.database;
  }

  public isEULAAccepted(): Observable<boolean> {
    if (typeof this._isEULAAccepted === 'boolean') return of(this._isEULAAccepted);

    const rideViewEULAStatus = JSON.parse(sessionStorage.getItem('rideview:EULA'));

    // eula credentials already exist for the user
    if (rideViewEULAStatus && rideViewEULAStatus[this.credentials.userName]) {
      this._isEULAAccepted = true;
      return of(this._isEULAAccepted);
    } else {
      // todo - pass these credentials from the geotab addin script
      // todo - store this adding id and the structure of the json in a ts structure
      return this.httpClient
        .post('https://my.geotab.com/apiv1', {
          method: 'Get',
          params: {
            typeName: 'AddInData',
            search: {
              addInId: 'aGyzk3AUkxkOQXMmPvKpxFg', // todo put this in env file
              selectClause: 'eulaAccepted',
              whereClause: `userName = \"${this.credentials.userName}\"`, // todo - configure user id over here
            },
            credentials: this.credentials,
          },
        })
        .pipe(
          map((v: any) => {
            this._isEULAAccepted = Boolean(v && v.result && v.result.length > 0 && v.result[0].details);
            if (this._isEULAAccepted) this.storeInBrowserStorage(true);
            return Boolean(this._isEULAAccepted);
          }),
          catchError(() => {
            this._isEULAAccepted = false;
            return of(this._isEULAAccepted);
          })
        );
    }
  }

  public declineEula() {
    // todo - redirect to dashboard
    this.storeInBrowserStorage(false);
  }

  public acceptEula() {
    this.httpClient
      .post('https://my.geotab.com/apiv1', {
        method: 'Add',
        params: {
          typeName: 'AddInData',
          entity: {
            addInId: 'aGyzk3AUkxkOQXMmPvKpxFg', // todo put this in env file
            details: {
              eulaAccepted: true,
              userName: this.credentials.userName, // change this user
            },
          },
          credentials: this.credentials,
        },
      })
      .subscribe({
        next: () => {
          this._isEULAAccepted = null;
          this.storeInBrowserStorage(true);
          this.router.navigateByUrl('geotab-login');
        },
      });
    // set value in localstorage and in geotab storage
    // * store in browserStorage so that when the user comes again to any other addin page, api call is not made again
  }

  private storeInBrowserStorage(eulaStatus: boolean) {
    const rideViewEULAStatus = JSON.parse(sessionStorage.getItem('rideview:EULA'));
    const data = {
      ...rideViewEULAStatus,
      [this.credentials.userName]: eulaStatus,
    };
    window.sessionStorage.setItem('rideview:EULA', JSON.stringify(data));
  }
}
